"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KvStore = void 0;
const cbor_1 = require("../../../message/cbor");
const utils_1 = require("../../../utils");
exports.KvStore = {
    _namespace_: "kvStore",
    async info() {
        const res = await this.call("kvstore.info");
        return getKVStoreInfo(res);
    },
    async get(param) {
        const data = makeKVStoreGet(param);
        const res = await this.call("kvstore.get", data);
        return getKVStoreValue(res);
    },
    async put(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeKVStorePut(param);
        await this.call("kvstore.put", data, { nonce });
    },
    async query(param) {
        const data = makeKVStoreGet(param);
        const res = await this.call("kvstore.query", data);
        return getKVStoreQuery(res);
    },
    async disable(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeKVStoreDisable(param);
        await this.call("kvstore.disable", data, { nonce });
    },
    async transfer(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeKVStoreTransfer(param);
        await this.call("kvstore.transfer", data, { nonce });
    },
};
// Make maps from objects
function makeKVStoreGet(param) {
    const data = new Map();
    data.set(0, Buffer.from(param.key));
    return data;
}
function makeKVStorePut(param) {
    const data = new Map();
    data.set(0, Buffer.from(param.key));
    data.set(1, Buffer.from(param.value));
    param.owner && data.set(2, (0, cbor_1.tag)(10000, param.owner));
    return data;
}
function makeKVStoreDisable(param) {
    const data = new Map();
    data.set(0, Buffer.from(param.key));
    param.owner && data.set(1, (0, cbor_1.tag)(10000, param.owner));
    return data;
}
function makeKVStoreTransfer(param) {
    const data = new Map();
    data.set(0, Buffer.from(param.key));
    data.set(2, (0, cbor_1.tag)(10000, param.newOwner));
    param.owner && data.set(1, (0, cbor_1.tag)(10000, param.owner));
    return data;
}
// Get objects from maps
function getKVStoreInfo(message) {
    const data = message.getPayload();
    const result = {
        hash: Buffer.from(data.get(0)).toString("hex"),
    };
    return result;
}
function getKVStoreValue(message) {
    const data = message.getPayload();
    const result = {
        value: data.get(0),
    };
    return result;
}
function getKVStoreQuery(message) {
    const data = message.getPayload();
    const result = {
        owner: data.get(0),
        enabled: data.get(1),
    };
    return result;
}
